import { createRoot } from "react-dom/client";
import App from "./App";

// Crear la raíz de React una sola vez
const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
